export class BaseProductAttributes {
    description: string;
    name: string;
    excluded: boolean;
    hidden: boolean;
    maximum: number;
    minimum: number;
    formValue: string;
    id: number;
    productId: number;
    mutable: boolean;
    showDrawMapPlan: boolean;
    isCommonAttribute: boolean;
    required: boolean;
    isRequired?: boolean;
    sortorder: number;
    titleNumberAttribute: boolean;
    bespokeAttribute: boolean;
    type: any;
    values: BaseProductAttributesValues[];
    readonly: boolean;
    invalidAttribute: boolean;
  }

  export class BaseProductAttributesValues {
    default: boolean;
    description: string;
    id: number;
    sortOrder: number;
    value: string;
    price: number;
    isBespokePrice: boolean;
    amountProposed: string;
  }

  export function attributeValueSort(a:BaseProductAttributesValues, b:BaseProductAttributesValues): number {
    if (a.description > b.description) {
      return 1;
    }
    if (a.description < b.description) {
      return -1;
    }
    return 0;
  }
